import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CompanyLicenceModel } from "services/api/cplauthapi/CPLAuthAPI";
import { ILicenceService } from "services/LicenceService";
import { RootState } from "setup";
import { container } from "setup/dependency/inversify.config";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

const initialState = {
  companyLicence: undefined as undefined | CompanyLicenceModel,
};

const licenceBannerSlice = createSlice({
  name: "licenceBanner",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCompanyLicence.fulfilled, (state, action) => {
      state.companyLicence = action.payload;
    });
  },
});

export const fetchCompanyLicence = createAsyncThunk("licenceBanner/fetchCompanyLicence", async () => {
  const licenceService = container.get<ILicenceService>(SERVICE_TYPES.LicenceService);
  return await licenceService.getCompanyLicence();
});

export const selectCompanyLicence = (state: RootState) => state.licenceBanner.companyLicence;

export default licenceBannerSlice.reducer;
